import type { ProjectManagerCandidate } from '@/types/project';

export function formatManagerCandidateLabel(candidate: ProjectManagerCandidate): string {
  const roleHint =
    candidate.source === 'DEPARTMENT_MANAGER'
      ? '部门负责人'
      : candidate.source === 'LEADER'
        ? '领导'
        : '成员';
  return `${candidate.name}（${candidate.phone}）· ${roleHint} · ${candidate.departmentName}`;
}

export function toManagerSelectOptions(candidates: ProjectManagerCandidate[]) {
  return candidates.map((candidate) => ({
    value: candidate.userId,
    label: formatManagerCandidateLabel(candidate),
  }));
}
